export const POSTS_LIKE_UNLIKE = 'POSTS_LIKE_UNLIKE';
export const CREATE = 'CREATE';
export const ALL_POSTS_LIKES = 'ALL_POSTS_LIKES';
export const ONE_POST_LIKE = 'ONE_POST_LIKE';
export const ALL_POST_COMMENT_LIKES = 'ALL_POST_COMMENT_LIKES';
export const COMMENT_LIKE_UNLIKE = 'COMMENT_LIKE_UNLIKE';
